import React from "react";
import { Button as MuiButton, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0.5),
  },
  label: {
    textTransform: "none",
  },
  btnPrimary: {
    backgroundColor: theme.palette.btnPrimary.main,
    height: theme.palette.btnPrimary.height,
    width: (props) => props.width || theme.palette.btnPrimary.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "center",
    fontWeight: 500,
    "& .MuiButton-label": {
      color: theme.palette.btnPrimary.contrastText,
      textTransform: "none",
      whiteSpace:'nowrap'
    },
    "&:hover": {
      backgroundColor: theme.palette.btnPrimary.mid,
      boxShadow: "none",
    },
    [theme.breakpoints.up("tablet")]:{
      height:"48px"
    }
  },
  btnPrimary1: {
    backgroundColor: theme.palette.btnPrimary.main,
    height: 32,
    width: (props) => props.width || theme.palette.btnPrimary.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "center",
    fontWeight: 500,
    "& .MuiButton-label": {
      color: theme.palette.btnPrimary.contrastText,
      textTransform: "none",
      whiteSpace:'nowrap'
    },
    "&:hover": {
      backgroundColor: theme.palette.btnPrimary.mid,
      boxShadow: "none",
    },
    [theme.breakpoints.up("tablet")]:{
      height:"40px"
    }
  },
  btnSecondary: {
    backgroundColor: theme.palette.primary.light,
    border: `1px solid ${theme.palette.btnPrimary.main}`,
    boxShadow: "none",
    height: theme.palette.btnPrimary.height,
    width: (props) => props.width || theme.palette.btnPrimary.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "center",
    fontWeight: 500,
    "& .MuiButton-label": {
      color: theme.palette.btnPrimary.main,
      textTransform: "none",
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      boxShadow: "none",
    },
  },
  btnTertiaryTwo: {
    backgroundColor: theme.palette.primary.light,
    border: `1px solid ${theme.palette.primary.light}`,
    boxShadow: "none",
    height: theme.palette.btnPrimary.height,
    width: (props) => props.width || theme.palette.btnPrimary.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Roboto",
    fontSize: "16px",
    letterSpacing: "0em",
    lineHeight: "24px",
    textAlign: "center",
    fontStyle: "normal",
    fontWeight: 500,
    "& .MuiButton-label": {
      color: theme.palette.btnPrimary.tertiaryText,
      textTransform: "none",
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      boxShadow: "none",
    },
  },
  btnLightBlue: {
    backgroundColor: theme.palette.btnPrimary.mid,
    height: theme.palette.btnPrimary.height,
    width: (props) => props.width || theme.palette.btnPrimary.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "left",
    fontWeight: 500,
    "& .MuiButton-label": {
      color: theme.palette.btnPrimary.contrastText,
      textTransform: "none",
    },
    "&:hover": {
      backgroundColor: theme.palette.btnPrimary.mid,
      boxShadow: "none",
    },
  },
  btnGray: {
    backgroundColor: "#C4C4C4",
    height: theme.palette.btnPrimary.height,
    width: (props) => props.width || theme.palette.btnPrimary.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "center",
    fontWeight: 500,
    "& .MuiButton-label": {
      color: theme.palette.btnPrimary.contrastText,
      textTransform: "none",
    },
    "&:hover": {
      backgroundColor: "#C4C4C4",
      boxShadow: "none",
    },
  },

  btnTransparent: {
    backgroundColor: "#FFFFFF",
    border: `1px solid #C4C4C4`,
    boxShadow: "none",
    height: theme.palette.btnPrimary.height,
    width: (props) => props.width || theme.palette.btnPrimary.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "center",
    fontWeight: 500,
    "& .MuiButton-label": {
      color:  "#C4C4C4",
      textTransform: "none",
    },
    "&:hover": {
      backgroundColor: "#FFFFFF",
      boxShadow: "none",
    },
  },
  googleButton:{
    backgroundColor: "#FFFFFF",
    border: `none`,
    boxShadow: "2px 2px 4px rgb(47 47 47 / 12%)",
    height: theme.palette.btnPrimary.height,
    width: (props) => props.width || theme.palette.btnPrimary.width,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontStyle: "normal",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "center",
    fontWeight: 500,
    "& .MuiButton-label": {
      color: "#787878",
      textTransform: "none",
    },
    "&:hover": {
      backgroundColor: "#FFFFFF",
      boxShadow: "none",
    },
  }
}));

export default function Button(props) {
  const { text, size, color, label, variant, onClick, width, ...other } = props;
  const classes = useStyles(props);

  return (
    <MuiButton
      variant={variant || "contained"}
      size={size || "large"}
      onClick={onClick}
      {...other}
      className={`${classes[color]}`}
    >
      {text}
    </MuiButton>
  );
}
